var _defs, _g, _polygon, _polygon2, _polygon3, _polygon4, _g2, _path, _path2, _polygon5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 299.84 127.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #13347D;\n      }\n\n      .cls-4 {\n        fill: #de1927;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 300,
    height: 127.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 300,
    height: 127.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0,
    y: 0,
    width: 300,
    height: 127.25,
    rx: 3.09,
    ry: 3.09
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "55.89 22.54 69.54 52.64 87.75 13.74 108.59 13.74 122.33 113.76 95.66 113.76 89.83 72.65 89.55 72.65 69.54 113.76 50.67 72.97 55.89 22.54"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "24.4 13.75 13.49 113.76 38.81 113.76 49.73 13.75 24.4 13.75"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "128.54 13.87 155.71 13.87 155.77 27.26 141.77 27.26 141.77 32.54 152.19 32.54 152.19 45.91 141.77 45.91 141.77 51.2 155.72 51.2 155.77 64.57 128.54 64.57 128.54 13.87"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "161.13 13.87 192.4 13.87 192.32 26.69 183.38 26.69 183.38 64.57 170.15 64.57 170.15 26.69 161.16 26.69 161.13 13.87"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m197.54,13.87h17.39c10.07,0,17.04,5.5,17.04,16.27,0,5.42-2.46,9.51-6.9,12.47l9.71,21.97h-14.93l-8.94-20.91h-.14v20.91h-13.23V13.87Zm13.23,23.8c4.93,0,7.95-1.69,7.95-6.27s-3.02-6.27-7.95-6.27v12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m260.98,64.96c-13.69,0-25.2-11.5-25.2-25.74s11.51-25.74,25.2-25.74,25.19,11.5,25.19,25.74-11.51,25.74-25.19,25.74m0-38.27c-6.61,0-12.13,5.59-12.13,12.53s5.52,12.53,12.13,12.53,12.12-5.86,12.12-12.53-5.45-12.53-12.12-12.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m165.8,95.56c2.35-1.74,3.55-4.19,3.55-7.26,0-2.91-.87-5.28-2.6-7.05-1.75-1.78-4.14-2.66-7.14-2.66h-23.45v35.09h23.13c3.71,0,6.53-.77,8.43-2.33,1.9-1.56,2.85-3.92,2.85-6.99,0-4.36-1.59-7.36-4.75-8.8m-24.34-11.33h18.43c1.35,0,2.37.39,3.13,1.17.76.79,1.14,1.83,1.14,3.2,0,1.26-.42,2.3-1.27,3.17-.86.87-1.9,1.3-3.2,1.3h-18.22v-8.84Zm17.86,23.81h-17.86v-9.32h18.62c3.45.03,5.01,1.54,5.04,4.83-.03,3.02-1.82,4.46-5.81,4.49"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m194.71,78.64h-6.17l-15.66,35.12h5.36l3.41-7.85h19.94l3.4,7.85h5.37l-15.65-35.12Zm-10.3,21.78l7.25-16.19,7.17,16.19h-14.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m238.97,113.76l-18.68-27.84v27.84h-5.31v-35.08h6.36l18.69,27.85v-27.85h5.31v35.08h-6.37Zm6.14-.23v-.24.24Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "286.21 113.38 286.51 113.76 279.7 113.76 265.84 95.71 259.19 103.12 259.19 113.76 253.89 113.76 253.89 78.68 259.19 78.68 259.19 96.28 277.35 78.68 285.06 78.68 269.83 92.05 286.21 113.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogo);
export default __webpack_public_path__ + "static/media/appLogo.9b4ad4ec0a25ade1ac43e378f0b750a6.svg";
export { ForwardRef as ReactComponent };